var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height mt-3",attrs:{"dense":"","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"pr-3",attrs:{"flat":"","outlined":""}},[_c('tbl-calculation-comp-conc-limits',{attrs:{"components":_vm.COMPONENTS}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }